// Phase 6 Step 2 — screen-as-data: URL codec (pure; strings only — no DOM/browser globals, keep the
// portability grep clean by keeping those token words out of comments too).
//
// Serializes a "screen" (the shareable view: active filters + their values, preset, RS cohort, sort) to a
// compact, URL-safe token and back. UTF-8-safe (encodeURIComponent handles a unicode `group` substring)
// without the deprecated escape/unescape. decode() returns null on ANY error — a hand-mangled ?s= must
// degrade the app to defaults, never throw / white-screen.
//
// Screen shape (compact, fk-keyed so it maps 1:1 to the DOM controls + buildScreenTree):
//   { v:1, f:{ <fk>:<stringValue> }, p?:preset, c?:{k,s}, s?:[sortKey,sortDir] }
// `f` holds the value of every ACTIVE filter; p/c/s omitted at their defaults.

export const SCREEN_URL_VERSION = 1;

function b64urlEncode(bin) {
    // btoa is available in both the browser and Node (global). base64 → base64url.
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function b64urlDecode(s) {
    let b = s.replace(/-/g, '+').replace(/_/g, '/');
    while (b.length % 4) b += '=';
    return atob(b);
}

/** Encode a screen object to a compact URL-safe token. */
export function encodeScreen(screen) {
    // encodeURIComponent → ASCII (%XX for non-latin1) → btoa-safe → base64url. UTF-8 lossless.
    return b64urlEncode(encodeURIComponent(JSON.stringify(screen)));
}

/** Decode a token back to a screen object, or null on any malformed/unknown-version input. */
export function decodeScreen(token) {
    try {
        if (!token || typeof token !== 'string') return null;
        const screen = JSON.parse(decodeURIComponent(b64urlDecode(token)));
        if (!screen || typeof screen !== 'object' || screen.v !== SCREEN_URL_VERSION) return null;
        return screen;
    } catch (e) {
        return null;
    }
}
